import React from 'react'
import { Link } from 'react-router-dom'

// Constants
import { routes } from '@sketch/constants'

import {
  LinkSection,
  LinkListItem,
  HeaderListItem,
  LinkListPrototypeCards,
  LinkListPrototypeCard,
} from './AboutTab.styles'

// Icons
import { ReactComponent as PrototypeIcon } from '@sketch/icons/prototype-hotspot-16-svg'
import { ReactComponent as PageIcon } from '@sketch/icons/canvas-page-16-svg'
import { ReactComponent as ComponentsIcon } from '@sketch/icons/components-16-svg'

// Qraphql
import { ShareAboutFragment } from '@sketch/gql-types'

import { usePagesURL } from './AboutTab.hooks'
import PrototypeCard from '../PrototypeCard'
import { useVersioning } from 'modules/versioning'
import { getArtboardThumbnail } from 'modules/shares/utils'
import { Tooltip } from '@sketch/components'

interface AboutTabLinkSectionProps {
  share: ShareAboutFragment
}

const AboutTabLinkSection: React.FC<AboutTabLinkSectionProps> = ({ share }) => {
  const { document } = share.version || {}
  const { componentCount, pages, prototypes } = document || {}
  const prototypeArtboards = prototypes?.entries || []
  const { getPathname } = useVersioning()

  const pagesUrl = usePagesURL(share)
  const shareID = share.identifier

  const componentsCountTotal =
    (componentCount?.symbol || 0) +
    (componentCount?.textStyle || 0) +
    (componentCount?.layerStyle || 0) +
    (componentCount?.colorVar || 0)

  return (
    <LinkSection>
      <HeaderListItem>Views</HeaderListItem>
      {pages?.entries[0] && (
        <Link to={pagesUrl}>
          <LinkListItem icon={PageIcon}>
            {`Pages (${pages?.meta.totalCount || 0})`}
          </LinkListItem>
        </Link>
      )}
      <Link to={routes.CWV_SYMBOLS.create({ shareID })}>
        <LinkListItem icon={ComponentsIcon}>
          {`Components (${componentsCountTotal})`}
        </LinkListItem>
      </Link>
      <Link to={routes.SHARE_PROTOTYPES.create({ shareID })}>
        <LinkListItem icon={PrototypeIcon}>
          {`Prototypes (${prototypes?.meta.totalCount || 0})`}
        </LinkListItem>
      </Link>
      <LinkListPrototypeCards>
        {prototypeArtboards.map(artboard => (
          <LinkListPrototypeCard key={artboard.uuid}>
            <Tooltip content={artboard.name} placement="bottom">
              <PrototypeCard
                pathname={getPathname({
                  routeKey: 'PROTOTYPE_VIEW',
                  routeParams: { shareID, artboardUUID: artboard.uuid },
                })}
                title={artboard.name}
                src={getArtboardThumbnail(artboard)}
                showTitle={false}
                showDropdown={false}
                iconSize={32}
              />
            </Tooltip>
          </LinkListPrototypeCard>
        ))}
      </LinkListPrototypeCards>
    </LinkSection>
  )
}

export default AboutTabLinkSection
